export default __webpack_public_path__ + "static/media/header-isp.fbb523b8.jpg";